import { Reveal, MaskedLines } from "@/components/Reveal";
import { CTAGroup } from "@/components/CTAButtons";

export function PageHero({ kicker, title, titleLines, intro, image, imageAlt, category }) {
  return (
    <section className="relative min-h-[78vh] w-full overflow-hidden pt-24" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
      </div>
      <div className="relative z-10 mx-auto flex min-h-[78vh] max-w-[1400px] flex-col justify-end px-5 pb-16 md:px-10 md:pb-24">
        <p className="label mb-6 text-wine">{kicker}</p>
        <h1 className="max-w-4xl font-display text-4xl leading-[1.02] sm:text-6xl lg:text-7xl">
          {titleLines ? <MaskedLines lines={titleLines} /> : title}
        </h1>
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">{intro}</p>
          <div className="mt-10">
            <CTAGroup category={category} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CTABanner({ title = "Ready when you are.", sub = "Book online in under a minute — or call and we'll find your perfect time.", category }) {
  return (
    <section className="relative overflow-hidden border-y border-border bg-secondary/40" data-testid="cta-banner">
      <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <Reveal>
          <p className="label mb-6 text-wine">Book your appointment</p>
          <h2 className="max-w-3xl font-display text-4xl leading-[1.05] md:text-6xl">{title}</h2>
          <p className="mt-6 max-w-xl text-muted-foreground">{sub}</p>
          <div className="mt-10">
            <CTAGroup category={category} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function SectionKicker({ children, className = "" }) {
  return <p className={`label mb-6 text-wine ${className}`}>{children}</p>;
}
